export const mockDonationReceipt = {
  data: {
    originalFilename: 'PXL_20230220_185728520.jpg',
    url: 'test.img'
  },
  object: 'donation_match_request_receipt'
}
